import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=84e98a2e&scoped=true&"
import script from "./Default.vue?vue&type=script&lang=ts&"
export * from "./Default.vue?vue&type=script&lang=ts&"
import style0 from "./Default.vue?vue&type=style&index=0&id=84e98a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e98a2e",
  null
  
)

export default component.exports